import React, {useState} from 'react';
import { Formik, Field, Form } from 'formik';
import {pick} from 'underscore'
import './SubMenuInlineForm.css'
import {debounce} from 'lodash'
import db from '../Firebase'


let editableKeys = [
  'description', 'draft', 'name', 'disableOrder', 'tag', 'section'
]

const sectionOptions = ['Food', 'Drinks', 'Desserts', 'Catering']

const SubMenuInlineForm = ({ subMenu }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  
  return (
    <div className="sub-menu-inline-wrapper">
      {/* <h1>Edit User</h1> */}
      <Formik
        initialValues={pick(subMenu.data(), editableKeys) /** { email, social } */}
        onSubmit={debounce((values, actions) => {
          console.log(values)
          subMenu.ref.update(values).then(() => (actions.setSubmitting(false)))

        }, 1000)}
        render={({ errors, touched, isSubmitting, values, handleSubmit, handleChange }) => {
          const changeWithSave = (e) => {
            handleChange(e) // the effects is setImmediate
            setTimeout(() => handleSubmit(e), 0)
          }
          return(
            <Form className="sub-menu-inline-form">

              {/* <Field type="code" name="code" /> */}
              <Field onChange={changeWithSave} type="text" name="name.en" />
              <Field onChange={changeWithSave} component="textarea" name="description.en" />
              <label className="checkbox-label">
                <Field onChange={changeWithSave} type="checkbox" name="draft" checked={values.draft} />
                Draft
              </label>
              <label className="checkbox-label">
                <Field onChange={changeWithSave} type="checkbox" name="disableOrder" checked={values.disableOrder} />
                Disable Order
              </label>
              <Field onChange={changeWithSave} type="text" name="tag" placeholder="tag" />
              <Field 
                onChange={changeWithSave} 
                type="text" 
                name="section" 
                placeholder="section" 
                list="section-options"
              />
              <datalist id="section-options">
                {sectionOptions.map(option => (
                  <option key={option} value={option} />
                ))}
              </datalist>


              {/* <button type="submit" disabled={isSubmitting}> */}
              {/* <button type="submit" >
                Save
              </button> */}
            </Form>
        )}}
      />
      <div className="sub-menu-actions">
        <button 
          type="button"
          className="menu-toggle" 
          onClick={(e) => {
            e.stopPropagation();
            setMenuOpen(!menuOpen);
          }}
          title="More actions"
        >
          ⋮
        </button>
        <div className="dropdown-menu" style={{ display: menuOpen ? 'block' : 'none' }}>
          <button 
            type="button"
            className="dropdown-menu-btn"
            onClick={async () => {
              const newShopId = prompt("Enter the destination restaurant's shop ID:");
              if (!newShopId) { 
                setMenuOpen(false);
                return; 
              }

              try {
                // Validate that the shopId exists
                const shopQuery = await db.collection('all')
                  .where('type', '==', 'shop')
                  .where('shopId', '==', newShopId)
                  .get();
                
                if (shopQuery.empty) {
                  alert(`Error: shopId "${newShopId}" doesn't exist`);
                  setMenuOpen(false);
                  return;
                }
                // First, create the new category and get its ID
                const newCategoryData = {
                  ...subMenu.data(),
                  shopId: newShopId,
                  orderIndex: [] // Will be populated with new product IDs
                };
                const newCategoryRef = await db.collection('all').add(newCategoryData);
                const newCategoryId = newCategoryRef.id;

                // Copy all products with new shopId and subMenuId
                const newProductIds = [];
                const productPromises = (subMenu.products || []).map(async (product) => {
                  const newProductData = {
                    ...product.data(),
                    shopId: newShopId,
                    subMenuId: newCategoryId
                  };
                  const newProductRef = await db.collection('all').add(newProductData);
                  newProductIds.push(newProductRef.id);
                  return newProductRef;
                });

                await Promise.all(productPromises);

                // Update the category's orderIndex with new product IDs
                await newCategoryRef.update({ orderIndex: newProductIds });

                // Update the shop's subMenusOrderIndex to include the new category
                const shopDoc = shopQuery.docs[0];
                const currentSubMenusOrderIndex = shopDoc.data().subMenusOrderIndex || [];
                await shopDoc.ref.update({
                  subMenusOrderIndex: [...currentSubMenusOrderIndex, newCategoryId]
                });
              } catch (error) {
                console.error('Error copying category:', error);
                alert('Error copying category: ' + error.message);
              }
              
              setMenuOpen(false);
            }}>
            Copy to Another Restaurant
          </button>
          <button 
            type="button"
            className="delete-category-btn"
            onClick={() => {
                const productCount = subMenu.products?.length || 0;
                if(window.confirm(`Delete category "${subMenu.get('name.en')}" and all ${productCount} products?`)) {
                  // Delete all products first
                  // console.log('deleting products')
                  const deletePromises = (subMenu.products || []).map(product => 
                    product.ref.delete()
                    // console.log(product.ref.parent.id)
                  );
                  Promise.all(deletePromises)
                    .then(() => subMenu.ref.delete())
                    .catch(console.log);
                }
                setMenuOpen(false);
              }}>
              Delete Category
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubMenuInlineForm
